import { Mail, Youtube } from "lucide-react";
import { motion } from "framer-motion";

export const Footer = () => (
  <footer data-testid="footer" className="relative overflow-hidden border-t border-white/10 pt-20">
    <div className="mx-auto max-w-[1600px] px-6 md:px-12">
      <motion.a
        href="https://bignick.ca"
        target="_blank"
        rel="noopener noreferrer"
        data-testid="footer-bignick-link"
        initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
        className="block font-serif text-[clamp(3rem,11vw,11rem)] font-black leading-none tracking-tighter text-[#F4F4F0]/10 transition-colors duration-700 hover:text-[#E63946]/60"
      >
        BIGNICK.CA
      </motion.a>

      <div className="mt-14 flex flex-col gap-8 border-t border-white/10 py-10 md:flex-row md:items-center md:justify-between">
        <p className="font-sans text-[10px] uppercase tracking-[0.3em] text-[#57534E]">
          © 2026 Samkhya Publishing · CRA-registered · Canada
        </p>
        <div className="flex items-center gap-8">
          <a
            href="mailto:samkhyapublishing@gmail.com"
            data-testid="footer-email-link"
            className="flex items-center gap-2 font-sans text-[10px] font-bold uppercase tracking-[0.25em] text-[#A8A29E] transition-colors duration-300 hover:text-[#F4F4F0]"
          >
            <Mail className="h-4 w-4" /> Email
          </a>
          <a
            href="http://www.youtube.com/@nicholaskfmatte3013"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-youtube-link"
            className="flex items-center gap-2 font-sans text-[10px] font-bold uppercase tracking-[0.25em] text-[#A8A29E] transition-colors duration-300 hover:text-[#F4F4F0]"
          >
            <Youtube className="h-4 w-4" /> YouTube
          </a>
          <a
            href="https://www.amazon.ca/s?k=Nicholas+K+F+Matte"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-amazon-link"
            className="flex items-center gap-2 font-sans text-[10px] font-bold uppercase tracking-[0.25em] text-[#A8A29E] transition-colors duration-300 hover:text-[#F4F4F0]"
          >
            Amazon
          </a>
        </div>
      </div>
    </div>
  </footer>
);
